/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SegmentIntegrationIntegrationsModel } from '../../models/segment-integration-integrations-model';

export interface PostSegmentIntegrations$Params {
  'Active-Tenant-Identifier': string;
      body: SegmentIntegrationIntegrationsModel
}

export function postSegmentIntegrations(http: HttpClient, rootUrl: string, params: PostSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
  const rb = new RequestBuilder(rootUrl, postSegmentIntegrations.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HalJson>;
    })
  );
}

postSegmentIntegrations.PATH = '/segment-integrations/integrations';
